import script from "./FileManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./FileManagement.vue?vue&type=script&setup=true&lang=js"

import "./FileManagement.vue?vue&type=style&index=0&id=68167254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68167254"]])

export default __exports__